import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DocumentService } from '../../financialTransaction/_services/document.service';
import { Document } from 'src/app/_models/document';
import { FileRestrictions, SuccessEvent, UploadEvent } from '@progress/kendo-angular-upload';
import { environment } from 'src/environments/environment';
import { NotifyService } from 'src/app/_services/notify.service';
import { Subscription, finalize } from 'rxjs';

@Component({
   selector: 'app-document',
   templateUrl: './document.component.html',
   styleUrls: ['./document.component.scss'],
})
export class DocumentComponent implements OnInit, OnDestroy {
   fileRestrictions: FileRestrictions = {
      allowedExtensions: ['.xls', '.xlsx', '.pdf', '.jpg', '.jpeg', '.png', '.bmp', 'tiff', '.txt', '.zip', '.rar', '.csv', '.docx', '.doc'],
      maxFileSize: 10 * 1024 * 1024,
   };
   @Input()
   heading = 'Documents';
   @Input()
   showUpload = true;
   @Input()
   id: any;
   loading = false;
   loadingDelete = false;
   documents: Document[];
   @Input()
   docType: string;
   @Input()
   isValidBooking = true;
   @Input()
   secondaryId = 0;

   baseUrl = environment.apiUrl;
   idToDelete = 0;
   deleteOpened = false;

   uploadSaveUrl = '';
   private documentSubscription: Subscription;
   constructor(private documentService: DocumentService, private notify: NotifyService) {}

   ngOnInit() {
      this.documentSubscription = this.documentService.transactionReceived.subscribe((d: any) => {
         this.id = d;
         if (d !== '') {
            this.getDocuments();
         }
      });

      if (this.id) {
         this.getDocuments();
      }
   }
   ngOnDestroy() {
      this.documentSubscription.unsubscribe();
   }
   getDocuments() {
      this.loading = true;
      if (this.secondaryId > 0) {
         this.id = this.secondaryId;
      }
      this.documentService.getDocuments(this.id, this.docType).subscribe(
         (docs: Document[]) => {
            this.documents = docs;
            this.documents.forEach((doc) => {
               doc.extension = doc.name.split('.').pop();
               switch (doc.extension) {
                  case 'jpg':
                     doc.icon = 'image';
                     break;
                  case 'tiff':
                     doc.icon = 'image';
                     break;
                  case 'jpeg':
                     doc.icon = 'image';
                     break;
                  case 'png':
                     doc.icon = 'image';
                     break;
                  case 'bmp':
                     doc.icon = 'image';
                     break;
                  case 'docx':
                     doc.icon = 'file-word';
                     break;
                  case 'doc':
                     doc.icon = 'file-word';
                     break;
                  case 'xlsx':
                     doc.icon = 'file-excel';
                     break;
                  case 'xls':
                     doc.icon = 'file-excel';
                     break;
                  case 'txt':
                     doc.icon = 'file-txt';
                     break;
                  case 'pdf':
                     doc.icon = 'file-pdf';
                     break;
                  case 'zip':
                     doc.icon = 'file-zip';
                     break;
                  case 'rar':
                     doc.icon = 'file-zip';
                     break;
                  case 'csv':
                     doc.icon = 'file-csv';
                     break;
                  default:
                     doc.icon = 'file';
                     break;
               }
            });

            this.uploadSaveUrl = this.baseUrl + 'document/' + this.docType + '/' + this.id;
            this.loading = false;
         },
         (error) => {
            const message = error;
            this.notify.error(message);
            this.loading = false;
         }
      );
   }

   successEventHandler(e: SuccessEvent) {
      if (e.response) {
         this.getDocuments();
         const message = 'Successfully uploaded document';
         this.notify.success(message);
      }
      this.loading = false;
   }
   export(id) {
      const link = document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.download = 'fileName';
      link.href = this.baseUrl + 'document/doc/' + this.docType + '/' + id;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
   }
   openDelete(id) {
      this.idToDelete = id;
      this.deleteOpened = true;
   }
   delete() {
      this.loadingDelete = true;
      this.documentService
         .deleteDocument(this.idToDelete.toString(), this.docType)
         .pipe(
            finalize(() => {
               this.loadingDelete = false;
            })
         )
         .subscribe({
            next: () => {
               this.closeDelete();
               const message = 'Successfully removed document';
               this.notify.success(message);
               this.getDocuments();
            },
            error: (error) => {
               const message = error;
               this.notify.error(message);
            },
         });
   }
   closeDelete() {
      this.deleteOpened = false;
   }
   errorEventHandler(e: any) {
      const message = !e.message ? e.response.error : e.message;
      this.notify.error(message);

      this.loading = false;
   }
   uploadEventHandler(e: UploadEvent) {
      e.headers = e.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      this.loading = true;
      e.data = {
         description: 'Logo',
         File: e.files[0].rawFile,
      };
   }
}
